import { render } from "./EditTaskForm.vue?vue&type=template&id=3c7264fb"
import script from "./EditTaskForm.vue?vue&type=script&lang=js"
export * from "./EditTaskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__